import React from "react";
import style from "./stylesheets/HintList.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const HintList = ({ hintData, userData, showEventStamps }) => {
    const hintsSorted = hintData.filter(hint => showEventStamps === hint.isEventStamp);

    if(showEventStamps) hintsSorted.sort((a, b) => a.eventEndTime - b.eventEndTime);
    else hintsSorted.sort((a, b) => a.releaseTime - b.releaseTime);

    const hints = hintsSorted.map(hint => {
        const foundByUser = userData && userData.foundHints.includes(hint.id);
        const eventIsInPast = hint.isEventStamp && hint.eventEndTime < Date.now();

        let paragraphText;
        if(eventIsInPast) paragraphText = `Event has passed`;
        else if(foundByUser && hint.isEventStamp) paragraphText = `Already visited`;
        else if(foundByUser && !hint.isEventStamp) paragraphText = `Already found`;
        else if(!foundByUser && hint.isEventStamp) paragraphText = `Not visited yet`;
        else if(!foundByUser && !hint.isEventStamp) paragraphText = `Not found yet`;

        return (
            <Link to={`/hint/${hint.id}`} key={hint.id}>
                <div className={`${style.hint} ${(foundByUser || eventIsInPast) && style.found}`}>
                    <div className={style.info_box}>
                        <h2>{hint.title}</h2>
                        <p>{paragraphText} • {hint.reward} points</p>
                    </div>
                    <p className={style.icon}>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </p>
                </div>
            </Link>
        );
    });

    return (
        <div className={style.hint_list}>
            {hints}
        </div>
    );
};

export default HintList;
